import Link from './Link';

export {Link};
